import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const _import = file => () => import('@/pages/' + file + '.vue')
const _importMobile = file => () => import('@/Mobile/' + file + '.vue')
export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: _import('home/index'),
      redirect: '/index',
      children: [
        {
          path: 'index',
          component: _import('Index/homePage'),
          meta: { 'title': '首页' }
        },
      ]
    },
    {
      name: 'digitalSystem',
      path: '/digitalSystem',
      component: _import('qccloud/digitalSystem'),
      meta: { 'title': '千橙微商城' }
    },
    {
      name: 'integration',
      path: '/integration',
      component: _import('qccloud/s2b2c'),
      meta: { 'title': '千橙S2B2C系统' }
    },
    {
      name: 'onlineAndOfflineIntegration',
      path: '/onlineAndOfflineIntegration',
      component: _import('qccloud/onlineAndOfflineIntegration'),
      meta: { 'title': '千橙连锁系统' }
    },
    {
      name: 'retailMall',
      path: '/retailMall',
      component: _import('qccloud/retailMall'),
      meta: { 'title': '千橙收银系统' }
    },
    {
      name: 'aiShopkeeper',
      path: '/aiShopkeeper',
      component: _import('product/aiShopkeeper'),
      meta: { 'title': 'AI超级店长' }
    },
    {
      name: 'coPlan',
      path: '/coPlan',
      component: _import('coPlan/coPlan'),
      meta: { 'title': '千橙AI合作伙伴计划' }
    },
    {
      name: 'leapoAI',
      path: '/leapoAI',
      component: _import('leapoAI/leapoAI'),
      meta: { 'title': 'LeapoAI' }
    },
    {
      name: 'nineToken',
      path: '/nineToken',
      component: _import('nineToken/nineToken'),
      meta: { 'title': '九词Token算力平台' }
    },
    {
      name: 'qcSuper',
      path: '/qcSuper',
      component: _import('qcSuper/qcSuper'),
      meta: { 'title': '千橙AI超级店长' }
    },
    {
      name: 'market',
      path: '/market',
      component: _import('market/market'),
      meta: { 'title': 'AI效果营销' }
    },
    {
      name: 'lm200',
      path: '/products/robot/lm200',
      component: _import('product/robot/lm200'),
      meta: { 'title': 'LM200 AI 智能零售巡检机器人' }
    },
    {
      name: 'lm201',
      path: '/products/robot/lm201',
      component: _import('product/robot/lm201'),
      meta: { 'title': 'LM201 AI 健康巡检机器人' }
    },
    {
      name: 'lm202',
      path: '/products/robot/lm202',
      component: _import('product/robot/lm202'),
      meta: { 'title': 'LM202 AI 智能零售巡检机器人' }
    },
    {
      name: 'lm203',
      path: '/products/robot/lm203',
      component: _import('product/robot/lm203'),
      meta: { 'title': 'LM203 AI 智能安保巡逻机器人' }
    },
        {
      name: 'lm211',
      path: '/products/robot/lm211',
      component: _import('product/robot/lm211'),
      meta: { 'title': 'LM211 AI智能零售机器人' }
    },
        {
      name: 'aiDataService',
      path: '/products/ai/data-service',
      component: _import('product/ai/data-service'),
      meta: { 'title': '企业级数据服务' }
    },
    {
      name: 'aiServer',
      path: '/products/ai/ai-server',
      component: _import('product/ai/ai-server'),
      meta: { 'title': '存算大模型一体机' }
    },
    {
      name: 'onlineErp',
      path: '/onlineErp',
      component: _import('qccloud/onlineErp'),
      meta: { 'title': '千橙ERP系统' }
    },
    {
      name: 'scrmProduct',
      path: '/scrmProduct',
      component: _import('qccloud/scrmProduct'),
      meta: { 'title': '汇团团社群营销系统' }
    },
    {
      name: 'intelligentService',
      path: '/intelligentService',
      component: _import('product/intelligentService'),
      meta: { 'title': '智能客服系统' }
    },
        {
      path: '/live',
      component: _import('qccloud/live'),
      name: 'live',
      meta: { 'title': '汇好看直播系统' }
    },
    {
      path: '/marketing',
      name: 'marketing',
      component: _import('qccloud/marketing'),
      meta: { 'title': '千橙会员营销系统' }
    },
    {
      path: '/QcDownload',
      name: 'QcDownload',
      component: _import('solution/QcDownload'),
      meta: { 'title': '产品下载体验' }
    },
    {
      path: '/b2bChannel',
      name: 'b2bChannel',
      component: _import('qccloud/b2bChannel'),
      meta: { 'title': '千橙B2b分销' }
    },
    {
      path: '/about',
      component: _import('about/index'),
      name: 'about',
      meta: { 'title': '关于我们' }
    },
    {
      path: '/business/ai',
      name: 'businessAi',
      component: _import('business/ai'),
      meta: { 'title': 'AI业务' }
    },
    {
      path: '/aiCreation',
      name: 'aiCreation',
      component: _import('product/ai/creation'),
      meta: { 'title': '千橙万象' }
    },
    {
      path: '/aiCall',
      name: 'aiCall',
      component: _import('product/ai/call'),
      meta: { 'title': 'AI 外呼' }
    },
    {
      path: '/aiAnalysis',
      name: 'aiAnalysis',
      component: _import('product/ai/analysis'),
      meta: { 'title': '行业分析' }
    },
    {
      path: '/business/cloud',
      name: 'businessCloud',
      component: _import('business/cloud'),
      meta: { 'title': '云服务业务' }
    },
    {
      path: '/business/robot',
      name: 'businessRobot',
      component: _import('business/robot'),
      meta: { 'title': '机器人业务' }
    },
    {
      path: '/news',
      name: 'news',
      component: _import('news/index'),
      meta: { 'title': '新闻发布' }
    },
    {
      path: '/news/detail/:id',
      name: 'newsDetail',
      component: _import('news/detail'),
      meta: { 'title': '新闻详情' }
    },
    {
      path: '/m',
      component: _importMobile('Home/index'),
      redirect: '/m/index',
      children: [
        {
          path: 'index',
          component: _importMobile('Index/index'),
          meta: { 'title': '首页' }
        },
        {
          path: 'cooperate',
          component: _importMobile('EcoPartner/Cooperate'),
          meta: { 'title': '渠道合作' }
        },
        {
          path: 'eco-partner',
          component: _importMobile('EcoPartner/Partner'),
          meta: { 'title': '生态伙伴' }
        },
        {
          path: 'introduce',
          component: _importMobile('EcoPartner/Introduction'),
          meta: { 'title': '企业简介' }
        },
        {
          path: 'dynamic',
          component: _importMobile('About/Dynamic'),
          meta: { 'title': '企业动态' }
        },
        {
          path: 'dynamicDetail/:id',
          component: _importMobile('About/DynamicDetail'),
          meta: { 'title': '新闻详情' }
        },
        // 千橙零售云
        {
          path: 'QcErpSystem',
          component: _importMobile('Solution/QcErpSystem'),
          meta: { 'title': '千橙ERP系统' }
        },
        {
          path: 'QcCashier',
          component: _importMobile('Solution/QcCashier'),
          meta: { 'title': '千橙收银系统' }
        },
        {
          path: 'QcDistribution',
          component: _importMobile('Solution/QcDistribution'),
          meta: { 'title': '千橙分销系统' }
        },
        {
          path: 'QcChain',
          component: _importMobile('Solution/QcChain'),
          meta: { 'title': '千橙连锁系统' }
        },
        {
          path: 'QcShopkeeper',
          component: _importMobile('Solution/QcShopkeeper'),
          meta: { 'title': '千橙新零售系统' }
        },
        {
          path: 'QcShoppingMall',
          component: _importMobile('Solution/QcShoppingMall'),
          meta: { 'title': '千橙微商城系统' }
        },
        {
          path: 'QcAssociation',
          component: _importMobile('Solution/QcAssociation'),
          meta: { 'title': '汇团团社群营销系统' }
        },
        {
          path: 'QcMarketing',
          component: _importMobile('Solution/QcMarketing'),
          meta: { 'title': '千橙会员营销系统' }
        },
        // 千橙云
        {
          path: 'QcCommerce',
          component: _importMobile('Solution/QcCommerce'),
          meta: { 'title': '千橙电商S2B2C系统' }
        },
        {
          path: 'QcB2BChannel',
          component: _importMobile('Solution/QcB2BChannel'),
          meta: { 'title': '千橙B2b分销系统' }
        },
        {
          path: 'QcLiveBroadcast',
          component: _importMobile('Solution/QcLiveBroadcast'),
          meta: { 'title': '汇好看直播电商' }
        },
        // 千橙服务云
        {
          path: 'QcTool',
          component: _importMobile('Solution/QcTool'),
          meta: { 'title': '千橙RPA工具箱' }
        },
        {
          path: 'QcDigit',
          component: _importMobile('Solution/QcDigit'),
          meta: { 'title': '千橙数字人' }
        },
        // 产品下载
        {
          path: 'QcDownload',
          component: _importMobile('Solution/QcDownload'),
          meta: { 'title': '产品下载体验' }
        },
        {
          path: 'TryModalPage',
          component: _importMobile('Mobilecom/TryModalPage'),
          meta: { 'title': '信息收集' }
        }
      ]
    },
    // 业务分类路由
    {
      name: 'MBusinessAi',
      path: '/m/business/ai',
      component: _importMobile('Business/Ai'),
      meta: { 'title': 'AI业务' }
    },
    {
      name: 'MBusinessCloud',
      path: '/m/business/cloud',
      component: _importMobile('Business/Cloud'),
      meta: { 'title': '云服务业务' }
    },
    {
      name: 'MBusinessRobot',
      path: '/m/business/robot',
      component: _importMobile('Business/Robot'),
      meta: { 'title': '机器人业务' }
    },
    {
      path: '/m/about',
      component: _importMobile('About/index'),
      name: 'MAbout',
      meta: { 'title': '关于我们' }
    },
    // 注册登录
    {
      path: '/registerLogin',
      component: _importMobile('RegisterLogin/registerLogin'),
      meta: { 'title': '注册试用' }
    },
    {
      path: '/404',
      component: _import('ErrorPages/404')
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})
